export enum OfferAdditionalInformationEnum {
  AcFixedSum = 'fixedSum',
  AcSparePartsOrOriginal = 'spare_parts_or_original',
  AssistanceMinHomeDistance = 'interrisk_assistance_min_home_distance_infotip',
}
